module.exports = __webpack_public_path__ + "img/empty-wallet.432edcbc.svg";